import { useMemo } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CompanyName from './CompanyName';
import { getNavigateToContactRecord } from '../constants/events';
import RecordLink from 'crm-links/record/RecordLink';
import UsageTrackerContext from '../context/UsageTrackerContext';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompanyInformation = ({
  associatedCompanyId,
  companyName,
  companyLink,
  compactDivider,
  includeEschref,
  external
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [compactDivider ? /*#__PURE__*/_jsx(Text, {
      as: "p",
      paddingInline: "100",
      color: "border-core-default",
      children: '|'
    }) : /*#__PURE__*/_jsx(View, {
      paddingInline: "100",
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-header.fromLabel"
      })
    }), /*#__PURE__*/_jsx(CompanyName, {
      associatedCompanyId: associatedCompanyId,
      companyName: companyName,
      companyLink: companyLink,
      external: external,
      includeEschref: includeEschref
    })]
  });
};
const isPhoneNumber = contactDetail => !isNaN(Number(contactDetail));
const ContactInformation = ({
  associatedCompanyId,
  companyName,
  contactDetail,
  contactLink,
  compact = false,
  compactDivider = false,
  external = false,
  includeEschref,
  isKnownContact,
  companyLink,
  renderAssociateContactButton,
  vid,
  trackEvent,
  truncate,
  truncateStringProps
}) => {
  const ContactComponent = useMemo(() => {
    if (includeEschref) {
      return /*#__PURE__*/_jsx(RecordLink, {
        external: external,
        includeEschref: includeEschref,
        LinkComponentProps: {
          truncate,
          truncateStringProps,
          style: {
            width: 'max-content'
          },
          ExternalIcon: () => null
        },
        objectId: vid,
        objectTypeId: "0-1",
        onTrackClick: () => trackEvent(getNavigateToContactRecord()),
        children: isPhoneNumber(contactDetail) ? /*#__PURE__*/_jsx(FormattedPhoneNumber, {
          value: contactDetail || ''
        }) : contactDetail
      });
    }
    return /*#__PURE__*/_jsx(Link, {
      href: contactLink,
      external: true,
      onClick: () => trackEvent(getNavigateToContactRecord()),
      inlineSize: "max-content",
      truncate: truncate,
      truncateStringProps: truncateStringProps,
      children: isPhoneNumber(contactDetail) ? /*#__PURE__*/_jsx(FormattedPhoneNumber, {
        value: contactDetail || ''
      }) : contactDetail
    });
  }, [contactDetail, contactLink, external, includeEschref, trackEvent, vid, truncate, truncateStringProps]);
  return /*#__PURE__*/_jsx(UsageTrackerContext.Provider, {
    value: trackEvent,
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      flexGrow: 1,
      justifyContent: "start",
      maxInlineSize: "fit-content",
      children: [/*#__PURE__*/_jsx(Box, {
        shrink: 0,
        "data-test-id": "ticket-header-contact-detail-link",
        maxInlineSize: compact ? '150px' : 'fit-content',
        children: isKnownContact ? ContactComponent : renderAssociateContactButton()
      }), /*#__PURE__*/_jsx(Flex, {
        maxInlineSize: compact ? '160px' : '400px',
        inlineSize: "fit-content",
        flexWrap: "nowrap",
        overflow: "hidden",
        children: companyName ? /*#__PURE__*/_jsx(CompanyInformation, {
          associatedCompanyId: associatedCompanyId,
          includeEschref: includeEschref,
          companyName: companyName,
          companyLink: companyLink,
          external: external,
          compactDivider: compactDivider
        }) : null
      })]
    })
  });
};
ContactInformation.displayName = 'ContactInformation';
CompanyInformation.displayName = 'CompanyInformation';
export default ContactInformation;